import { useState } from "react"
import { InputBottomPlaceholder } from "../../../../components/inputBottomPlaceholder/InputBottomPlaceholder"
import { LGBTButton } from "../../../../components/lgbtButton/LGBTButton"
import { useAppDispatch } from "../../../../hooks/redux"
import { InputNumber, InputNumberProps } from "antd"
import { updateMoney } from "../../../../store/app-slice/AppSlice"

export const UpdateMoney = ({onResult}:{onResult:()=>void}) =>{
    const onChange:InputNumberProps['onChange'] = (value)=>{
            debugger
            if(value==null)return
            setSumm(Number(value.toString().replace(",",".")))
        }
    const [summ,setSumm] = useState(0)
    const dispatch:any=useAppDispatch();
    async function saveResult (){
        dispatch(updateMoney(summ))
        setTimeout(function(){
            onResult()
        }, 1000); 
    }

    
    return (
        <div style={{width:"80vw"}}>
            <div style={{textAlign:"center"}}> 
                <InputNumber
                    variant={"underlined"}
                    style={{fontSize:"20px", width:"50vw"}}
                    onChange={onChange}
                    controls={false}
                    formatter={value => value!=null?value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '):"0"}
                    parser={(num) => num!=undefined?Number(num.toString().replace(',','.').replace(/\D/g, '')):0}
                    min={0}
                    max={10000000}
                    placeholder={"0"}
                    value={summ}
                    />
                    <div>Собрали, р</div>
            </div>

            
           <div style={{marginTop:"50px"}}>
                <LGBTButton onClick={saveResult} text={"Сохранить результат"}/>
           </div>
        </div>
    )
}